import { render, staticRenderFns } from "./payOpts.vue?vue&type=template&id=6f535f6f&"
import script from "./payOpts.vue?vue&type=script&lang=js&"
export * from "./payOpts.vue?vue&type=script&lang=js&"
import style0 from "./payOpts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports